var AUTH_TOKEN_KEY = "token";

export function getAuthToken(): string | null {
    if (typeof localStorage === "undefined") {
        return null;
    }
    try {
        return localStorage.getItem(AUTH_TOKEN_KEY);
    } catch (e) {
        return null;
    }
}

export function setAuthToken(token: string): void {
    if (typeof localStorage === "undefined" || !token) {
        return;
    }
    try {
        localStorage.setItem(AUTH_TOKEN_KEY, token);
    } catch (e) {
        // ignore storage failures on legacy browsers
    }
}

export function clearAuthToken(): void {
    if (typeof localStorage === "undefined") {
        return;
    }
    try {
        localStorage.removeItem(AUTH_TOKEN_KEY);
    } catch (e) {
        // ignore
    }
}

function extractAuthToken(data: { token?: string; access_token?: string } | null | undefined): string | null {
    if (!data) {
        return null;
    }
    if (data.token && data.token.length > 0) {
        return data.token;
    }
    if (data.access_token && data.access_token.length > 0) {
        return data.access_token;
    }
    return null;
}

export function persistAuthTokenFromResponse(data: { token?: string; access_token?: string } | null | undefined): boolean {
    var token = extractAuthToken(data);
    if (!token) {
        return false;
    }
    console.log("persistAuthTokenFromResponse", token);
    setAuthToken(token);
    return true;
}

export function getCookie(name: string): string | null {
    if (name === AUTH_TOKEN_KEY) {
        return getAuthToken();
    }

    if (typeof document === "undefined") {
        return null;
    }
    var cookies = document.cookie.split(";");
    var i: number;
    for (i = 0; i < cookies.length; i++) {
        var part = cookies[i].replace(/^\s+|\s+$/g, "");
        var eq = part.indexOf("=");
        if (eq === -1) {
            continue;
        }
        var key = part.substring(0, eq);
        if (key === name) {
            return decodeURIComponent(part.substring(eq + 1));
        }
    }
    return null;
}

export const cookieManager = {
    getCookies: function (): string {
        if (typeof document === "undefined") {
            return "";
        }
        return document.cookie || "";
    },
    getToken: getAuthToken,
    setToken: setAuthToken,
    clearToken: clearAuthToken,
};
